/*
 * Copyright 2022 Siemens
 */

import {SwwcCommandBar, SwwcCommandButton, SwwcCommandPipe} from '@com.siemens.plm.horizon/swwc/bindings/react';
import React from 'react';

export interface CommandBarProps {
  addCommand?: () => void;
  deleteAllCommand?: () => void;
  reloadCommand?: () => void;

  children?: React.ReactNode | ReadonlyArray<React.ReactNode>;
}

export class CommandBar extends React.Component<CommandBarProps> {
  override render() {
    return (
      <SwwcCommandBar orientation='horizontal'>
        {this.props.addCommand && (
          <SwwcCommandButton
            label='Add'
            icon='cmdAdd16'
            iconSize='md'
            orientation='horizontal'
            onClickEvent={this.props.addCommand}
          />
        )}
        {this.props.deleteAllCommand && (
          <SwwcCommandButton
            label='Delete all'
            icon='cmdTrash16'
            iconSize='md'
            orientation='horizontal'
            onClickEvent={this.props.deleteAllCommand}
          />
        )}
        {(this.props.addCommand || this.props.deleteAllCommand) && <SwwcCommandPipe />}
        {this.props.children}
        {this.props.children && <SwwcCommandPipe />}
        {this.props.reloadCommand && (
          <SwwcCommandButton
            label='Reload'
            icon='cmdRefresh16'
            iconSize='md'
            orientation='horizontal'
            onClickEvent={this.props.reloadCommand}
          />
        )}
      </SwwcCommandBar>
    );
  }
}
